<template>
  <div class="app-main-inner-row input-dialog">
    <el-form style="width:100%;height: 800px" label-position="right" label-width="120px">
      <el-row>
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="titleGrid.gridOptions"
          :column-defs="titleGrid.titleColumnDefs"
          :row-data="titleGrid.rowData"
          style="width:700px;height:200px;padding-bottom: 5px"
          @gridReady="params=>titleGrid.gridApi=params.api"
        />
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="$t('CargoMsg.InvoiceChannel')" required>
          <el-select v-model="from.invoiceChannel" no="invoiceChannel" :disabled="!isEdit" style="width:300px;" @change="invoiceChannelChange">
            <el-option
              v-for="item in SystemConstants.INVOICE_CHANNEL_STATUS"
              :key="item.code"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <!--诺诺网全电发票:NUONUO-->
        <div v-if="isNuoNuo">
          <el-form-item :label="'APPkey'" required>
            <el-input v-model="from.appKey" no="appKey" :disabled="!isEdit" class="input-color" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="'APPSecret'" required>
            <el-input v-model="from.appSecret" no="appSecret" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="'Token'" required>
            <el-input v-model="from.token" no="token" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
        </div>
        <!--百旺金穗云:BWJSY-->
        <div v-if="isBwjsy">
          <el-form-item :label="'APPId'" required>
            <el-input v-model="from.appKey" no="APPId" :disabled="!isEdit" class="input-color" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="'APPSecret'" required>
            <el-input v-model="from.appSecret" no="appSecret" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
        </div>
        <div v-if="isNuoNuo || isBwjsy">
          <el-form-item :label="$t('CargoMsg.Invoicer')" required>
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="invoiceGrid.gridOptions"
              :column-defs="invoiceGridColumnDefs"
              :row-data="finalInvoiceRowData"
              :style="(isBwjsy ? 'width:670px;' : 'width:500px;')+'height:200px;'"
              @gridReady="params=>invoiceGrid.gridApi=params.api"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.InvoicerConfig')" required>
            <el-radio-group v-model="from.invoiceIssuer" no="invoiceIssuer" :disabled="!isEdit" style="width:300px;">
              <el-radio no="OnlyInvoicer" :label="0" style="margin-right:10px">{{ $t('CargoMsg.OnlyInvoicer') }}</el-radio>
              <el-radio no="AllInvoicer" :label="1">{{ $t('CargoMsg.AllInvoicer') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-row>

      <!--自定义配置字段-->
      <el-row :gutter="10">
        <el-form-item :label="$t('CargoMsg.Cargo_CustomFields') + '1'">
          <el-input v-model="from.customField1" no="customField1" :disabled="!isEdit" style="width:300px;" />
          <el-tooltip v-if="isNuoNuo" :content="$t('CargoMsg.Cargo_NuoNuoTipOne')" placement="right-end" style="padding-left: 7px;">
            <i class="el-icon-warning" style="cursor: pointer;color: orange;" />
          </el-tooltip>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CustomFields') + '2'">
          <el-input v-model="from.customField2" no="customField2" :disabled="!isEdit" style="width:300px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CustomFields') + '3'">
          <el-input v-model="from.customField3" no="customField3" :disabled="!isEdit" style="width:300px;" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>

import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import { queryInvoiceTitleByOfficeFunc } from '@/api/sysManage/officeInvoiceTitle'
import { OfficeInvoiceTitle } from '@/class/model/sys/OfficeInvoiceTitle'

export default {
  name: 'OfficeInvoiceConfig',
  props: {
    isEdit: { type: Boolean, required: true, default: false },
    officeId: { type: Number, required: true }
  },
  data() {
    return {
      loading: true,
      SystemConstants,
      from: new OfficeInvoiceTitle().fillDefaultValue().getData(),
      documentManage: new DocumentManage(),
      titleGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          onRowClicked: this.onRowClick
        },
        gridParams: {},
        gridApi: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: [],
        titleColumnDefs: [
          {
            headerName: this.$t('Invoice.invoice_invoiceHeader'),
            field: 'invoiceTitle',
            suppressMenu: true,
            width: 220
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxNumber'), field: 'taxAccount', suppressMenu: true,
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_IsDefaultTitle'), field: 'isDefault', suppressMenu: true,
            width: 120,
            valueFormatter: params => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            }
          },
          {
            headerName: this.$t('CargoMsg.InvoiceChannel'), field: 'invoiceChannel', suppressMenu: true,
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.columnLabelFunc(SystemConstants.INVOICE_CHANNEL_STATUS, params.value)
            }
          }
        ]
      },
      invoiceGrid: { // 开票员列表
        gridOptions: {
          singleClickEdit: true,
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        gridParams: {},
        gridApi: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: []
      }
    }
  },
  computed: {
    finalInvoiceRowData() {
      return this.from.invoiceConfigs ? this.from.invoiceConfigs.filter(p => !p.deleted) : []
    },
    isNuoNuo() { // 诺诺全电
      return this.from.invoiceChannel === 1
    },
    isBwjsy() { // 百旺金穗云
      return this.from.invoiceChannel === 2
    },
    nuoNuoColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25, suppressMenu: true,
          sortable: false
        }, {
          headerName: this.$t('CargoMsg.Invoicer'), field: 'invoicer', colId: 'invoicer', width: 180,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_User,
              tagName: 'chineseName',
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value',
              filterable: true,
              clearable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultInvoiceIssuer'), field: 'defaultInvoiceIssuer', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.ExtensionNumber'), field: 'extensionNumber', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRenderer: params => {
            const invoicerAdd = this.documentManage.getPath('invoicerAdd')
            const invoicerDel = this.documentManage.getPath('invoicerDel')
            return `<div>
                        <a onclick="${invoicerAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${invoicerDel}('${params.data.uuid}', ${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }
      ]
    },
    bwjsyColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25, suppressMenu: true,
          sortable: false
        }, {
          headerName: this.$t('CargoMsg.Invoicer'), field: 'invoicer', colId: 'invoicer', width: 180,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_User,
              tagName: 'chineseName',
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value',
              filterable: true,
              clearable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultInvoiceIssuer'), field: 'defaultInvoiceIssuer', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.FEI_Kpzddm'), field: 'terminalCode', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.FEI_Yhdm'), field: 'userCode', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', suppressMenu: true,
          width: 120,
          editable: () => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRenderer: params => {
            const invoicerAdd = this.documentManage.getPath('invoicerAdd')
            const invoicerDel = this.documentManage.getPath('invoicerDel')
            return `<div>
                        <a onclick="${invoicerAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${invoicerDel}('${params.data.uuid}', ${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }
      ]
    },
    invoiceGridColumnDefs() {
      return this.isNuoNuo ? this.nuoNuoColumnDefs : this.bwjsyColumnDefs
    }
  },
  watch: {
    isEdit: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    },
    officeId: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('invoicerAdd', function() {
      context.invoicerAdd()
    })
    this.documentManage.set('invoicerDel', function(uuid, value) {
      context.invoicerDel(uuid, value)
    })
  },
  mounted() {
  },
  async created() {
    this.init()
  },
  methods: {
    invoiceChannelChange() {
      this.from.appKey = ''
      this.from.appSecret = ''
      this.from.token = ''
      this.from.invoiceIssuer = 0
      if (!this.from.invoiceChannel || this.from.invoiceChannel === 0 || (this.from.invoiceConfigs && this.from.invoiceConfigs.length > 0)) {
        for (const invocieConfig of this.from.invoiceConfigs) {
          this.invoicerDel(invocieConfig.uuid, invocieConfig.serialNumber)
        }
      }
      if (!this.from.invoiceConfigs || this.from.invoiceConfigs.length <= 0) {
        this.invoicerAdd()
      }
    },
    // 新增开票员
    invoicerAdd() {
      if (!this.isEdit) return
      if (!this.checkInvoiceConfig()) return
      const newInvoicer = {
        serialNumber: 0,
        invoicer: 0,
        extensionNumber: '',
        terminalCode: '',
        userCode: '',
        remark: '',
        officeUuid: this.from.uuid
      }
      if (!this.from.invoiceConfigs) {
        this.from.invoiceConfigs = []
      }
      this.from.invoiceConfigs.push(newInvoicer)
      this.addSerialNumber(this.finalInvoiceRowData)
    },
    // 删除开票员
    invoicerDel(uuid, serialNumber) {
      if (!this.isEdit) return
      if (this.from.invoiceConfigs && this.from.invoiceConfigs.length > 0) {
        for (const invocieConfig of this.from.invoiceConfigs) {
          if (invocieConfig.uuid && uuid && invocieConfig.uuid === uuid) {
            invocieConfig.serialNumber = 0
            invocieConfig.deleted = true
          }
        }
      }
      if ((uuid === 'undefined' || !uuid) && serialNumber) {
        this.from.invoiceConfigs = this.from.invoiceConfigs.filter(row => row.serialNumber !== serialNumber)
      }
      // 至少要留一条数据
      if (!this.finalInvoiceRowData || this.finalInvoiceRowData.length <= 0) {
        this.invoicerAdd()
      }
      this.addSerialNumber(this.finalInvoiceRowData)
    },
    // 显示列增加序号
    addSerialNumber(rowData) {
      if (rowData && rowData.length > 0) {
        rowData.forEach((item, index) => {
          if (!item.deleted) {
            item.serialNumber = index + 1
          }
        })
      }
    },
    // 验证分机号开票员是否填写完整
    checkInvoiceConfig() {
      const rowData = this.finalInvoiceRowData
      if (rowData && rowData.length > 0) {
        for (const item of rowData) {
          if (!item.invoicer || item.invoicer === 0) {
            this.$message.warning(this.$t('CargoMsg.Invoicer') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return false
          }
          if (this.isNuoNuo) {
            if (!item.extensionNumber) {
              this.$message.warning(this.$t('CargoMsg.ExtensionNumber') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
              return false
            }
          }
          if (this.isBwjsy) {
            if (!item.userCode) {
              this.$message.warning(this.$t('CargoMsg.FEI_Yhdm') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
              return false
            }
            if (!item.terminalCode) {
              this.$message.warning(this.$t('CargoMsg.FEI_Kpzddm') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
              return false
            }
          }
        }
      }
      return true
    },
    init() {
      if (this.officeId) {
        queryInvoiceTitleByOfficeFunc({ officeId: this.officeId }).then(res => {
          this.titleGrid.rowData = res.data
          if (this.titleGrid.rowData && this.titleGrid.rowData.length > 0) {
            this.from = this.titleGrid.rowData[0]
            this.titleGrid.gridApi.clearFocusedCell()
            this.addSerialNumber(this.from.invoiceConfigs)
          }
        })
      }
    },
    onCellChange(params) {
      if (params.colDef.field === 'defaultInvoiceIssuer') {
        for (const data of this.finalInvoiceRowData) {
          data.defaultInvoiceIssuer = false
        }
        if (params.newValue) {
          params.data.defaultInvoiceIssuer = true
        }
      }
      this.invoiceGrid.gridOptions.api.refreshCells({ force: true })
    },
    async onRowClick(event) {
      if (!event || !event.data) return
      this.from = event.data
      this.addSerialNumber(this.from.invoiceConfigs)
    }
  }
}
</script>
